import Header from "../header/header";

export default function NotFound() {
    return (
        <div>
            <Header />
            <img className="img-grow" src="/img/dissapointed.jpg" alt="Eric Charney Photo"/>
            <h1>(Page Not Found)</h1>
        </div>
    )
}